import React, { Component } from "react";

import * as actions from "../../actions";
import { connect } from "react-redux";
import Api from "../../util/Api";
import Util from "../../util/Util";
import Style from "style-it";
import { VCSS } from "../../css/voucher.js";
import { FETCH_SUPPLIERS_ALL } from "../../actions/types";
import UtilHelper from "../../util/UtilHelper";
import AddFixedAsset from "./AddFixedAsset";

class FixedAssetAddUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this.defaultFormData(),
      errors: {},
      fromWhos: []
    };
  }

  defaultRowData() {
    return Object.assign(
      {},
      {
        item_id: 0,
        item_code: "",
        description: "",
        quantity: 1,
        unit_price_fc: 0.0,
        discount_rate: 0,
        unit_id: 0,
        discount_amount_fc: 0,
        net_amount_fc: 0,
        vat_rate_type_id: 0,
        vat_amount_fc: 0
      }
    );
  }

  defaultFormData() {
    return {
      invoice: {
        supplier_id: 0
      },
      rows: [this.defaultRowData()],
      footer: {}
    };
  }

  defaultErrors() {
    return {
      rows: [
        {
          item_id: false,
          description: false,
          quantity: false,
          unit_price_fc: false,
          discount_rate: false,
          unit_id: false,
          discount_amount_fc: false,
          net_amount_fc: false,
          vat_rate_type_id: false,
          vat_amount_fc: false
        }
      ],
      invoice: {},
      footer: {}
    };
  }

  fetchFromWho() {
    this.props.fetchData("/supplier/showAll", FETCH_SUPPLIERS_ALL);
  }

  setFromWhos(nextProps) {
    if (nextProps.suppliersAll) {
      const fromWhos = nextProps.suppliersAll.filter(function(supplier) {
        return supplier.is_active === 1;
      });
      this.setState({ fromWhos: fromWhos });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.suppliersAll) this.setFromWhos(nextProps);
  }

  prepareInvoiceLineForEdit(line, isCopied) {
    let row = {};
    if (typeof line.quantity !== 'number' && !Number.isNaN(line.quantity)) {
      line.quantity = parseFloat(line.quantity);
    }
    if (!Number.isNaN(line.quantity)) {
      line.quantity = line.quantity.toFixed(6);
      var parts = line.quantity.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      line.quantity = parts.join(",");
    }

    if (!isCopied) row.id = line.id;
    row.asset_type_id = line.asset_type_id;
    row.description = line.description;
    row.quantity = line.quantity;
    row.unit_id = line.unit_id;
    row.vat_rate_type_id = line.vat_rate_type_id;
    row.discount_amount_fc = Util.convertDecimalToMoney(
      line.discount_amount_fc
    );
    row.discount_rate = Util.convertNumberToPercent(line.discount_rate);
    row.unit_price_fc = UtilHelper.money.convertDecimalToMoney(
      line.unit_price_fc
    );
    row.net_amount_fc = Util.convertDecimalToMoney(line.net_amount_fc);
    row.vat_amount_fc = Util.convertDecimalToMoney(line.vat_amount_fc);

    return row;
  }

  prepareInvoiceForEdit(fixedAsset) {
    let ret = {};

    ret.id = fixedAsset.id;
    ret.supplier_id = fixedAsset.supplier_id
      ? parseInt(fixedAsset.supplier_id, 10)
      : null;
    ret.currency = fixedAsset.currency;
    ret.currency_rate = Util.convertDecimalToMoneyNew(fixedAsset.currency_rate);
    ret.description = fixedAsset.description;
    ret.legal_no = fixedAsset.legal_no;
    ret.supplier_name = fixedAsset.supplier_name || "";
    ret.date = Util.convertFromDatabaseDate(fixedAsset.date);
    ret.due_date = fixedAsset.due_date
      ? Util.convertFromDatabaseDate(fixedAsset.due_date)
      : "";
    ret.updated_at = fixedAsset.updated_at || null;

    return ret;
  }

  componentWillMount() {
    var self = this;
    this.fetchFromWho();

    if (this.props.params && this.props.params.id) {
      const invoiceId = this.props.params.id;
      let formData = this.state.formData;
      Api.paralel(
        ["/fixedAssetInvoice/" + invoiceId, "/fixedAssetInvoiceLine/showAll/" + invoiceId],
        function(responses, error) {
          const docUrl = responses[0].fixedAssetInvoice?.document_url;
          if(docUrl && self.props.setAddDocument){
            const type = docUrl.split('.').pop()
            self.props.setAddDocument({uri: docUrl, type});
          }
          formData.invoice = self.prepareInvoiceForEdit(responses[0].fixedAssetInvoice);

          let lines = [];
          if (
            responses[1].fixed_asset_invoice_lines &&
            responses[1].fixed_asset_invoice_lines.length > 0
          ) {
            lines = responses[1].fixed_asset_invoice_lines;

            formData.rows = lines.map(function(line) {
              return self.prepareInvoiceLineForEdit(line, false);
            });
            self.setState({ formData: formData });
          }
        }
      );
    }
  }

  onCancel() {
    this.props.router.push("/dashboard/fixedAsset");
  }

  render() {
    const editId =
      this.props.params && this.props.params.id ? this.props.params.id : false;
    return Style.it(
      VCSS,
      <div>
        <AddFixedAsset
          {...this.state}
          editId={editId}
          onRefresh={this.fetchFromWho.bind(this)}
          errors={this.defaultErrors()}
          defaultErrors={() => this.defaultErrors()}
          defaultRowData={this.defaultRowData()}
          formData={this.state.formData}
          defaultFormData={() => this.defaultFormData()}
          onCancel={this.onCancel.bind(this)}
          viewOptions={this.props.viewOptions}
          redirectToBase={this.onCancel.bind(this)}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    suppliersAll: state.data.suppliersAll,
    viewOptions: state.data.viewOptions,
    pageLoading: state.page.loading
  };
}

export default connect(mapStateToProps, actions)(FixedAssetAddUpdate);
